<template>
  <div class="form-section">
    <b-row class="form-section__header-container">
      <b-col cols="12" md="6">
        <div class="d-flex gap-2 form-section__title-container">
          <h4 class="card-title">{{ title }}</h4>
          <i v-if="isError" class="icon-fill_alert-circle" />
        </div>
      </b-col>

      <b-col cols="12" md="6" class="form-section__collapse-toggle-container">
        <ToggleCollapsable
          :id="title.toLowerCase().split(' ').join('-')"
          :value="isVisible"
          @click="isVisible = !isVisible"
        />
      </b-col>
    </b-row>

    <b-collapse v-model="isVisible">
      <b-card class="form-section__body-container">
        <b-row>
          <b-col
            v-for="field in fields"
            :key="field.name"
            v-if="field.isShown !== false"
            :cols="field.type === 'textarea' ? 12 : 12"
            :md="field.type === 'textarea' ? 6 : 3"
          >
            <slot :name="field.name" :field="field">
              <FormulateInput
                v-bind="field"
                class="p-0"
                validation-behavior="live"
                :help="field?.validation?.includes('required')"
                :value="formValues[field.name]"
                :fullObject="fullObjects[field.name]"
                @input="($event) => handleUpdateFormValues({ key: field.name, value: $event })"
                @update:fullObject="
                  ($event) => handleUpdateFullObjects({ key: field.name, value: $event })
                "
              />
            </slot>
          </b-col>
        </b-row>
      </b-card>
    </b-collapse>
  </div>
</template>

<script>
import { EventBus } from '../lib/event-bus.js'
import ToggleCollapsable from './ToggleCollapsable'

export default {
  components: {
    ToggleCollapsable,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    fields: {
      type: Array,
      default: () => [],
    },
    formValues: {
      type: Object,
      default: () => {},
    },
    fullObjects: {
      type: Object,
      default: () => {},
    },
    isError: {
      type: Boolean,
      default: false,
    },
  },
  emit: ['update:formValues', 'update:fullObjects'],
  data() {
    return {
      isVisible: true,
    }
  },
  methods: {
    handleUpdateFormValues({ key, value }) {
      let newValue = value
      if (newValue == false || newValue == '') {
        newValue = null
      }

      this.$emit('update:formValues', { key, value: newValue })
      EventBus.$emit('remove-error', key)
    },
    handleUpdateFullObjects({ key, value }) {
      this.$emit('update:fullObjects', { key, value })
    },
  },
}
</script>

<style lang="scss" scoped>
.form-section {
  margin: 24px 0;

  &__header-container {
    margin-bottom: 12px;

    i {
      font-size: 20px;

      &:before {
        color: $red;
      }
    }
  }

  &__title-container {
    display: flex;
    gap: 4px;
  }

  &__collapse-toggle-container {
    display: flex;
    justify-content: end;
  }
}
</style>
